import Apify from '@wetransfer/transfer/modules/apify';

export interface AllocateAssetPayload {
  asset_model_class: string;
  account_id: number;
  image_path: string;
  original_asset_filename: string;
}

export interface AllocateCurratedWallpaperPayload {
  account_id: number;
  image_path: string;
}

const methods = {
  getAssetUploadPresignedForm: {
    path: '/api/v4/user-uploaded-assets/presigned-form',
  },

  allocateAsset: {
    path: '/api/v4/user-uploaded-assets/preallocate',
    method: 'POST',
  },

  allocateCuratedImage: {
    path: '/api/v4/user-uploaded-assets/preallocate-curated',
    method: 'POST',
  },

  processPreviews: {
    path: '/api/v4/user-uploaded-assets/process-previews',
    method: 'POST',
  },

  getPreviewUrls: {
    path: '/api/v4/user-uploaded-assets/preview-urls/{asset_model_class}/{asset_model_id}',
    method: 'GET',
    pathExt: true,
  },

  getTiersPricing: {
    path: '/api/v4/nu_subscriptions/tiers',
    method: 'GET',
  },
} as const;

export default Apify<typeof methods>(methods);
